export const APP_STORE_LINK = "https://apps.apple.com/br/app/herofit";
export const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.herofit";

